import React, { useState } from "react";
import "./ContactUs.css";
import { getAssetPath } from "../../services/helpers";
import { useContactUsQueryMutation } from "../../services/userAuthApi";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

const ContactUs = () => {
    const [error, setError] = useState({
        status: false,
        msg: "",
        type: "",
    });
    const [success, setSuccess] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    // Validation Schema
    const validationSchema = Yup.object().shape({
        name: Yup.string()
            .required('Name is required')
            .min(3, 'Name must be at least 3 characters')
            .matches(
                /^[A-Z][a-zA-Z]*(?: [A-Z][a-zA-Z]*)*$/,
                'Name must contain only alphabets and space'
            ),
        email: Yup.string()
            .required('Email is required')
            .matches(
                new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
                "Please enter a valid email"
            )
            .email('Invalid email address'),
        mobile: Yup.string()
            .required('Mobile number is required')
            .matches(/^[0-9]{10}$/, 'Invalid mobile number'),
        subject: Yup.string()
            .required('Subject is required'),
        message: Yup.string()
            .required('Message is required'),
    });

    const [contactUsUser] = useContactUsQueryMutation();

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        setError({ status: false, msg: "", type: "" });
        setSuccess("");
        setIsLoading(true);

        const formData = {
            name: values.name,
            email: values.email,
            mobile: values.mobile,
            subject: values.subject || 'General Inquiry',
            message: values.message,
        };

        if (
            formData.name &&
            formData.email &&
            formData.mobile &&
            formData.subject &&
            formData.message
        ) {
            try {
                const res = await contactUsUser(formData);

                // FIX: Matches your API response object format directly
                if (res.data && res.data.success === true) {
                    setSuccess(res.data.message || "Contact request submitted successfully.");
                    resetForm(); // Successfully clears form fields
                }

                if (res.error) {
                    if (
                        res.error.data?.message &&
                        Array.isArray(res.error.data.message) &&
                        res.error.data.message.length > 1
                    ) {
                        const errorMsg = (
                            <ul>
                                {res.error.data.message.map((msg, index) => (
                                    <li key={index}>{msg}</li>
                                ))}
                            </ul>
                        );
                        setError({ status: true, msg: errorMsg, type: "error" });
                    } else {
                        setError({
                            status: true,
                            msg: res.error.data?.message || "An unexpected error occurred.",
                            type: "error",
                        });
                    }
                }
            } catch (err) {
                setError({
                    status: true,
                    msg: "Server connection failed. Please try again later.",
                    type: "error",
                });
            }
        } else {
            setError({ status: true, msg: "All fields are required.", type: "error" });
        }
        setIsLoading(false);
        setSubmitting(false);
    };

    return (
        <>
            <main className="main_wrapper">
                <div className="inn-ban">
                    <div className="container">
                        <div className="row">
                            <h1>Contact Us</h1>
                            <p>Creating memorable moments through cultural, social, and matrimonial events.</p>
                        </div>
                    </div>
                </div>

                <section className="git">
                    <div className="container">
                        <div className="matrimony-card">
                            <div className="row g-0">
                                <div className="col-lg-5">
                                    <div className="step-sidebar" style={{paddingBottom:"100px"}}>
                                        <div className="leaf-top">
                                            <img alt="" src={`${process.env.PUBLIC_URL}/assets/imgs/8.png`} />
                                        </div>
                                        {/* <div className="leaf-bottom">
                                            <img alt="" src={`${process.env.PUBLIC_URL}/assets/imgs/5.png`} />
                                        </div> */}
                                        <div className="login_regi_left p-0 background_none">
                                            <h4>Now</h4>
                                            <h1 style={{lineHeight:"56px"}} className="m-0">Contact <br /> to us</h1>
                                            <h4>Easy and fast.</h4>

                                            <div className="contact_details">
                                                <div className="c_icon">
                                                    <i className="fa-solid fa-location-dot"></i>
                                                </div>
                                                <div className="con_d">
                                                    <h5>Address:<br />
                                                        <span>101, Jai Laxminarayan Society, Lokmanya Tilak Marg, Mulund(E) Mumbai - 400081</span>
                                                    </h5>
                                                </div>
                                            </div>

                                            <div className="contact_details">
                                                <div className="c_icon">
                                                    <i className="fa-solid fa-phone"></i>
                                                </div>
                                                <div className="con_d">
                                                    <h5>Phone:<br /> <span>7021057077</span></h5>
                                                </div>
                                            </div>

                                            <div className="contact_details">
                                                <div className="c_icon">
                                                    <i className="fa-solid fa-envelope"></i>
                                                </div>
                                                <div className="con_d">
                                                    <h5>Email:<br /> <span>support@vikasmandalmulund.com</span></h5>
                                                </div>
                                            </div>
                                            <div className="contact_details">
                                                
                                                <div className="con_d ms-0">
                                                    <h5>Office Hours:<br /> <span>Evening 4:30 to 8:30, Monday to Saturday (Not available on Sundays and public holidays)</span></h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="log-bg"></div>
                                    </div>
                                </div>

                                <div className="col-lg-7">
                                    <div className="form-section">
                                        <div className="log_re_heading">
                                            <h2>Send your enquiry now</h2>
                                            <p>Reach out today and let us help you with the right solution.</p>
                                        </div>
                                        <div className="form-animate">
                                            {error.status ? (
                                                <div className="alert alert-danger">{error.msg}</div>
                                            ) : null}
                                            {success && (
                                                <div className="alert alert-success">{success}</div>
                                            )}

                                            <Formik
                                                initialValues={{
                                                    name: '',
                                                    email: '',
                                                    mobile: '',
                                                    subject: '',
                                                    message: ''
                                                }}
                                                validationSchema={validationSchema}
                                                onSubmit={handleSubmit}
                                            >
                                                {({ isSubmitting, isValid }) => (
                                                    <Form id="contact-uS-form">
                                                        <div className="col-md-12">
                                                            <div className="row">
                                                                <div className="col-lg-12 col-md-12">
                                                                    <div className="inputcontainer">
                                                                        <h5 className="input_label">Name</h5>
                                                                        <Field name="name">
                                                                            {({ field, form }) => (
                                                                                <input
                                                                                    {...field}
                                                                                    type="text"
                                                                                    id="name"
                                                                                    placeholder="Enter Your Name"
                                                                                    className="form-control input_style text-capitalize" // Added Tailwind/CSS text-capitalize for seamless visual masking
                                                                                    onChange={(e) => {
                                                                                        const rawValue = e.target.value;

                                                                                        // Automatically capitalizes the first letter of every word as they type
                                                                                        const capitalizedValue = rawValue.replace(/\b\w/g, (char) => char.toUpperCase());

                                                                                        // Update Formik state manually with the capitalized string
                                                                                        form.setFieldValue("name", capitalizedValue);
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        </Field>
                                                                        {/*<Field
                                                                            placeholder="Enter Your Name"
                                                                            id="name"
                                                                            name="name"
                                                                            className="form-control input_style text-capitalize"
                                                                            type="text"
                                                                        />*/}
                                                                        <ErrorMessage
                                                                            name="name"
                                                                            component="div"
                                                                            className="error-message"
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="col-lg-12 col-md-12">
                                                                    <h5 className="input_label">Email ID</h5>
                                                                    <div className="inputcontainer">
                                                                        <Field
                                                                            placeholder="Enter Email ID"
                                                                            id="email"
                                                                            name="email"
                                                                            className="form-control input_style"
                                                                            type="text"
                                                                        />
                                                                        <ErrorMessage
                                                                            name="email"
                                                                            component="div"
                                                                            className="error-message"
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="col-lg-6 col-md-6">
                                                                    <h5 className="input_label">Mobile Number</h5>
                                                                    <div className="inputcontainer">
                                                                        <Field
                                                                            placeholder="Enter Mobile Number"
                                                                            id="mobile"
                                                                            name="mobile"
                                                                            className="form-control input_style"
                                                                            type="text"
                                                                        />
                                                                        <ErrorMessage
                                                                            name="mobile"
                                                                            component="div"
                                                                            className="error-message"
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="col-lg-6 col-md-6">
                                                                    <h5 className="input_label">Subject</h5>
                                                                    <div className="inputcontainer">
                                                                        <Field
                                                                            placeholder="Enter Subject"
                                                                            id="subject"
                                                                            name="subject"
                                                                            className="form-control input_style"
                                                                            type="text"
                                                                        />
                                                                        <ErrorMessage
                                                                            name="subject"
                                                                            component="div"
                                                                            className="error-message"
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="col-lg-12 col-md-12">
                                                                    <h5 className="input_label">Message</h5>
                                                                    <div className="inputcontainer">
                                                                        <Field
                                                                            placeholder="Enter Here..."
                                                                            className="form-control input_style"
                                                                            id="message"
                                                                            name="message"
                                                                            rows="3"
                                                                            as="textarea"
                                                                        />
                                                                        <ErrorMessage
                                                                            name="message"
                                                                            component="div"
                                                                            className="error-message"
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="col-lg-12 col-md-12">
                                                                    <button
                                                                        className="btn btn next-btn w-100"
                                                                        type="submit"
                                                                        disabled={isSubmitting || !isValid}
                                                                    >
                                                                        {isLoading ? (
                                                                            <div className="loader">Please wait ..</div>
                                                                        ) : (
                                                                            "Submit"
                                                                        )}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Form>
                                                )}
                                            </Formik>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
};

export default ContactUs;